import { render } from "./GalleryPreview.vue?vue&type=template&id=b7823640"
import script from "./GalleryPreview.vue?vue&type=script&lang=js"
export * from "./GalleryPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__